// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.questionnaire-preview-modal {
  overflow: auto;
  opacity: 0;
  visibility: hidden;
  height: 100vh;
  width: 100vw;
  transition: 0.3s ease-in-out;
  position: fixed;
  background-color: rgba(255, 255, 255, 0.85);
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 270px;
}
.questionnaire-preview-modal.visible {
  opacity: 1;
  visibility: visible;
}
.questionnaire-preview-modal .form-section {
  margin-top: 270px;
  margin-bottom: 50px;
  min-height: 700px !important;
  width: 740px !important;
  background: #FFFFFF;
  box-shadow: 0px 4px 20px rgba(53, 99, 55, 0.2);
  border-radius: 10px;
  padding: 50px;
  display: flex;
  flex-direction: column;
}
.questionnaire-preview-modal .form-section .section-title {
  margin: 0;
  font-weight: 700;
  font-size: 20px;
  color: var(--secondary-color-1);
}
.questionnaire-preview-modal .form-section .section-title > span {
  font-size: 14px;
  font-weight: 600;
  color: #6C767C;
}
.questionnaire-preview-modal .form-section .form-input > label {
  font-size: 14px;
  font-weight: 600;
  color: var(--secondary-color-5);
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.questionnaire-preview-modal .form-section .options {
  display: flex;
  align-items: center;
  font-family: "Proxima Nova", sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: var(--secondary-color-1);
}
.questionnaire-preview-modal .form-section .options > input {
  flex: none;
}
.questionnaire-preview-modal .form-section .section-subtitle {
  margin-top: 8px;
  font-weight: 500;
  font-size: 14px;
  color: #B6B6B6;
}
.questionnaire-preview-modal .form-section .approval-pill {
  width: -moz-fit-content;
  width: fit-content;
  margin: 0;
  font-family: "Proxima Nova", sans-serif;
  border-radius: 5px;
  padding: 7px 14px;
  background-color: #FEF4D2;
  color: var(--primary-color-1);
  font-weight: 700;
}
.questionnaire-preview-modal .form-section .sublabel {
  font-size: 14px;
  font-weight: 600;
  color: var(--secondary-color-3);
  line-height: 25px;
}
.questionnaire-preview-modal .form-section .sublabel.option {
  padding-left: 37px;
  position: relative;
}
.questionnaire-preview-modal .form-section .sublabel.option::before {
  content: "";
  position: absolute;
  height: 4px;
  width: 4px;
  background-color: var(--secondary-color-3);
  border-radius: 10px;
  top: 10px;
  left: 30px;
}
.questionnaire-preview-modal .form-section .sublabel > mark {
  text-decoration: underline;
  background: none;
  color: inherit;
  font-weight: 700;
}
.questionnaire-preview-modal .form-section .sublabel > mark.colored {
  text-decoration: none;
  color: var(--primary-color-1);
}
.questionnaire-preview-modal .form-section .fotenote {
  font-family: "Proxima Nova", sans-serif;
  font-weight: 700;
}
.questionnaire-preview-modal .form-section .fotenote > p {
  font-size: 18px;
  margin: 0;
  color: var(--secondary-color-1);
}
.questionnaire-preview-modal .form-section .fotenote > span {
  font-weight: 14px;
  color: #B6B6B6;
}
.questionnaire-preview-modal .form-section > button {
  height: 45px;
  font-size: 16px;
}
.questionnaire-preview-modal .form-section > button.cancel {
  background: var(--secondary-color-4);
  color: var(--secondary-color-3);
}
.questionnaire-preview-modal .form-section > button.cancel:hover {
  opacity: 0.75;
}`, "",{"version":3,"sources":["webpack://./src/components/QuestionnairePreview/questionnairePreview.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,2CAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AACJ;AAAI;EACI,UAAA;EACA,mBAAA;AAER;AAAI;EACI,iBAAA;EACA,mBAAA;EACA,4BAAA;EACA,uBAAA;EACA,mBAAA;EACA,8CAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAER;AADQ;EACI,SAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;AAGZ;AAFY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAIhB;AAAY;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAEhB;AACQ;EACI,aAAA;EACA,mBAAA;EACA,uCAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;AACZ;AAAY;EACI,UAAA;AAEhB;AACQ;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AACZ;AACQ;EACI,uBAAA;EAAA,kBAAA;EACA,SAAA;EACA,uCAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,6BAAA;EACA,gBAAA;AACZ;AACQ;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,iBAAA;AACZ;AAAY;EACI,kBAAA;EACA,kBAAA;AAEhB;AADgB;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,0CAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;AAGpB;AAAY;EACI,0BAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAEhB;AADgB;EACI,qBAAA;EACA,6BAAA;AAGpB;AACQ;EACI,uCAAA;EACA,gBAAA;AACZ;AAAY;EACI,eAAA;EACA,SAAA;EACA,+BAAA;AAEhB;AAAY;EACI,iBAAA;EACA,cAAA;AAEhB;AACQ;EACI,YAAA;EACA,eAAA;AACZ;AAAY;EACI,oCAAA;EACA,+BAAA;AAEhB;AADgB;EAAU,aAAA;AAI1B","sourcesContent":[".questionnaire-preview-modal {\r\n    overflow: auto;\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    height: 100vh;\r\n    width: 100vw;\r\n    transition: .3s ease-in-out;\r\n    position: fixed;\r\n    background-color: rgba($color: white, $alpha: .85);\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 999;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding-top: 270px;\r\n    &.visible {\r\n        opacity: 1;\r\n        visibility: visible;\r\n    }\r\n    .form-section {\r\n        margin-top: 270px;\r\n        margin-bottom: 50px;\r\n        min-height: 700px !important;\r\n        width: 740px !important;\r\n        background: #FFFFFF;\r\n        box-shadow: 0px 4px 20px rgba(53, 99, 55, 0.2);\r\n        border-radius: 10px;\r\n        padding: 50px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        .section-title {\r\n            margin: 0;\r\n            font-weight: 700;\r\n            font-size: 20px;\r\n            color: var(--secondary-color-1);\r\n            > span {\r\n                font-size: 14px;\r\n                font-weight: 600;\r\n                color: #6C767C;\r\n            }\r\n        }\r\n        .form-input {\r\n            > label {\r\n                font-size: 14px;\r\n                font-weight: 600;\r\n                color: var(--secondary-color-5);\r\n                display: flex;\r\n                align-items: center;\r\n                margin-bottom: 5px;\r\n            }\r\n        }\r\n        .options {\r\n            display: flex;\r\n            align-items: center;\r\n            font-family: 'Proxima Nova', sans-serif;\r\n            font-weight: 700;\r\n            font-size: 16px;\r\n            color: var(--secondary-color-1);\r\n            > input {\r\n                flex: none;\r\n            }\r\n        }\r\n        .section-subtitle {\r\n            margin-top: 8px;\r\n            font-weight: 500;\r\n            font-size: 14px;\r\n            color: #B6B6B6;\r\n        }\r\n        .approval-pill {\r\n            width: fit-content;\r\n            margin: 0;\r\n            font-family: 'Proxima Nova', sans-serif;\r\n            border-radius: 5px;\r\n            padding: 7px 14px;\r\n            background-color: #FEF4D2;\r\n            color: var(--primary-color-1);\r\n            font-weight: 700;\r\n        }\r\n        .sublabel {\r\n            font-size: 14px;\r\n            font-weight: 600;\r\n            color: var(--secondary-color-3);\r\n            line-height: 25px;\r\n            &.option {\r\n                padding-left: 37px;\r\n                position: relative;\r\n                &::before {\r\n                    content: '';\r\n                    position: absolute;\r\n                    height: 4px;\r\n                    width: 4px;\r\n                    background-color: var(--secondary-color-3);\r\n                    border-radius: 10px;\r\n                    top: 10px;\r\n                    left: 30px;\r\n                }\r\n            }\r\n            > mark {\r\n                text-decoration: underline;\r\n                background: none;\r\n                color: inherit;\r\n                font-weight: 700;\r\n                &.colored {\r\n                    text-decoration: none;\r\n                    color: var(--primary-color-1);\r\n                }\r\n            }\r\n        }\r\n        .fotenote {\r\n            font-family: 'Proxima Nova', sans-serif;\r\n            font-weight: 700;\r\n            > p { \r\n                font-size: 18px;\r\n                margin: 0;\r\n                color: var(--secondary-color-1);\r\n            }\r\n            > span {\r\n                font-weight: 14px;\r\n                color: #B6B6B6;\r\n            }\r\n        }\r\n        > button {\r\n            height: 45px;\r\n            font-size: 16px;\r\n            &.cancel {\r\n                background: var(--secondary-color-4);\r\n                color: var(--secondary-color-3);\r\n                &:hover { opacity: .75; }\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
